// extracted by mini-css-extract-plugin
module.exports = {"container":"TickerNav_container__3-33P","bin":"TickerNav_bin__DTRaD"};